import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridAngular } from 'ag-grid-angular';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '../../../../components/directives.module';
import { RegimenSopListComponent } from './list.component';

const ROUTES: Routes = [
  { path: '', component: RegimenSopListComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DirectivesModule,
    RouterModule.forChild(ROUTES),
    AgGridAngular,
  ],
  declarations: [RegimenSopListComponent],
  exports: [RegimenSopListComponent],
})
export class RegimenSopListModule {}
